/* Angular Libraries */
import {Component} from '@angular/core';
import { Router} from '@angular/router';
/* External Libraries */
import {TranslateService} from '@ngx-translate/core';


@Component({
	selector: 'app-navigation',
	templateUrl: './navigation.component.html',
	styleUrls: ['./navigation.component.scss'],
})
export class NavigationComponent {

	constructor(
		public translate: TranslateService,
		public router: Router,
	) {
		
	}
}
